exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-wizard-step-indicator{align-items:center;display:flex;padding-right:16px;width:100%}.ba-common-wizard-step-indicator svg{fill:#1f57a4;margin-right:8px}.ba-common-wizard-step-indicator>div{display:inline}", ""]);

// exports
exports.locals = {
	"wizardStepIndicatorClassName": "\"ba-common-wizard-step-indicator\""
};